import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Toast from 'components/Toast';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';
import i18n from 'i18n-react';
import clsx from 'clsx';

export default class MultipleChoice extends Component {
  constructor(props) {
    super(props);

    const { answersCorrect } = this.props;
    const answerStyles = answersCorrect.map((answer) => (answer === 'true' ? 'correct' : ''));
    const activeStyles = answersCorrect.map(() => '');

    this.state = {
      selectedAnswers: [],
      answerStyles,
      activeStyles,
      toastContent: null,
      headerImage: '',
      // quiz mode state
      quizAnswered: false,
      quizOptionStyles: answersCorrect.map(() => ''),
      quizMCSelected: answersCorrect.map(() => false),
    };

    this.changeAnswer = this.changeAnswer.bind(this);
    this.handleQuizAnswer = this.handleQuizAnswer.bind(this);
    this.handleQuizMCToggle = this.handleQuizMCToggle.bind(this);
    this.handleQuizMCConfirm = this.handleQuizMCConfirm.bind(this);
  }

  componentDidMount() {
    this.setHeader();
  }

  componentDidUpdate(prevProps) {
    const { quizTimerExpired, quizMode } = this.props;
    if (quizMode && quizTimerExpired && !prevProps.quizTimerExpired && !this.state.quizAnswered) {
      this.handleTimerExpiry();
    }
  }

  async setHeader() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { questionHeader } = appInfo;
    this.setState({ headerImage: questionHeader });
  }

  resetForm() {
    const selected = [];
    const { children } = document.querySelector('.form__answers');
    Array.from(children).forEach((element, index) => {
      const input = document.getElementById(index);
      selected.push(input.checked.toString());
      this.setState({ selectedAnswers: selected });
    });
  }

  checkAnswers(answersCorrect, clickedAnswer) {
    const { selectedAnswers, activeStyles, answerStyles } = this.state;
    const { error, incorrectAnswerText, correctAnswerText } = this.props;
    const newStyles = activeStyles;

    if (selectedAnswers.length === 0) {
      return i18n.translate('trainingScreens.choose');
    }
    const allCorrect = selectedAnswers.every(
      (answer, index) => answer.toString().toLowerCase() === answersCorrect[index].toString().toLowerCase(),
    );

    const i = clickedAnswer.parentNode.htmlFor;
    newStyles[i] = answerStyles[i];
    if (allCorrect) {
      this.props.contentComplete();
      this.setState({
        activeStyles: newStyles,
        toastContent: {
          type: 'success',
          position: 'top-center',
          content: correctAnswerText,
        },
      });
      return correctAnswerText;
    }
    this.resetForm();
    error(true);
    return incorrectAnswerText;
  }

  checkImageAnswer(answersCorrect) {
    const { selectedAnswers, activeStyles } = this.state;
    const { error, incorrectAnswerText, correctAnswerText } = this.props;
    const newStyles = activeStyles;

    const allCorrect = selectedAnswers.every((answer, i) => answer === answersCorrect[i]);
    if (allCorrect) {
      this.props.contentComplete();
      this.setState({
        activeStyles: newStyles,
        toastContent: {
          position: 'top-center',
          content: correctAnswerText,
        },
      });
      return correctAnswerText;
    }

    error(true);
    return incorrectAnswerText;
  }

  changeAnswer(target, layout, answersCorrect) {
    const selected = [];
    const form = document.querySelector('.form__answers');
    Array.from(form.children).forEach((element, index) => {
      const input = document.getElementById(index);
      selected.push(input.checked.toString());
    });
    this.setState({ selectedAnswers: selected }, () => {
      if (layout !== 'mMC') {
        this.checkAnswers(answersCorrect, target);
      }
    });
  }

  changeImageAnswer(e, answersCorrect) {
    const { length } = document.querySelector('.form__answers').children;
    const selectedAnswers = [];
    for (let i = 0; i < length; i += 1) {
      if (i.toString() === e.target.id) {
        selectedAnswers.push(true);
      } else selectedAnswers.push(false);
    }
    this.setState({ selectedAnswers }, () => {
      this.checkImageAnswer(answersCorrect);
    });
  }

  // ── Quiz mode ───────────────────────────────────────────────────────────────

  handleQuizAnswer(clickedIndex) {
    if (this.state.quizAnswered) return;

    const { answersCorrect, contentComplete, error } = this.props;

    const isTrue = (v) => v === true || (typeof v === 'string' && v.toLowerCase() === 'true');
    const isCorrect = isTrue(answersCorrect[clickedIndex]);

    const newStyles = answersCorrect.map((ans, i) => {
      if (isTrue(ans)) return 'quiz-mode-option--correct';
      if (i === clickedIndex) return 'quiz-mode-option--wrong';
      return '';
    });

    this.setState({ quizAnswered: true, quizOptionStyles: newStyles });

    if (isCorrect) {
      contentComplete();
    } else {
      error(true);
    }
  }

  handleQuizMCToggle(clickedIndex) {
    if (this.state.quizAnswered) return;
    this.setState((prevState) => {
      const quizMCSelected = [...prevState.quizMCSelected];
      quizMCSelected[clickedIndex] = !quizMCSelected[clickedIndex];
      return { quizMCSelected };
    });
  }

  handleQuizMCConfirm() {
    if (this.state.quizAnswered) return;
    const { answersCorrect, contentComplete, error } = this.props;
    const { quizMCSelected } = this.state;

    const isTrue = (v) => v === true || (typeof v === 'string' && v.toLowerCase() === 'true');
    const allCorrect = answersCorrect.every((ans, i) => isTrue(ans) === quizMCSelected[i]);

    const newStyles = answersCorrect.map((ans, i) => {
      if (isTrue(ans)) return 'quiz-mode-option--correct';
      if (quizMCSelected[i]) return 'quiz-mode-option--wrong';
      return '';
    });

    this.setState({ quizAnswered: true, quizOptionStyles: newStyles });

    if (allCorrect) {
      contentComplete();
    } else {
      error(true);
    }
  }

  handleTimerExpiry() {
    const { answersCorrect, error } = this.props;

    const isTrue = (v) => v === true || (typeof v === 'string' && v.toLowerCase() === 'true');
    const newStyles = answersCorrect.map((ans) => (isTrue(ans) ? 'quiz-mode-option--correct' : ''));

    this.setState({ quizAnswered: true, quizOptionStyles: newStyles });

    // Timer expiry counts as a wrong answer — the highlighting reveals the correct answer.
    error(true);
  }

  // ── Render ──────────────────────────────────────────────────────────────────

  renderQuizMode() {
    const { question, answer, answersCorrect, layout, error } = this.props;
    const { quizAnswered, quizOptionStyles, quizMCSelected } = this.state;

    const isImage = layout === 'mCI';
    const isMC = layout === 'mMC';
    const isTrue = (v) => v === true || (typeof v === 'string' && v.toLowerCase() === 'true');

    return (
      <div className="quiz-mode-card">
        <h4 className="container__title">{question}</h4>
        <div className={clsx('quiz-mode-card__options', { 'quiz-mode-card__options--image-grid': isImage })}>
          {answer.map((text, index) => {
            const optStyle = quizOptionStyles[index];
            const showCheck = quizAnswered && isTrue(answersCorrect[index]);
            const showWrong = quizAnswered && optStyle === 'quiz-mode-option--wrong';
            const isSelected = isMC && !quizAnswered && quizMCSelected[index];
            // For mMC, always use checkbox style — no letters at any stage
            const showCheckbox = isMC && !quizMCSelected[index];
            const imageSrc = isImage ? text.replace(' ', '_').toLowerCase() : null;

            const letterContent = isMC
              ? (quizMCSelected[index] ? <FontAwesomeIcon icon={['fas', 'check']} /> : null)
              : String.fromCharCode(65 + index);

            return (
              <button
                key={index}
                className={clsx(
                  'quiz-mode-option',
                  { 'quiz-mode-option--image': isImage },
                  { 'quiz-mode-option--selected': isSelected },
                  optStyle,
                )}
                onClick={() => (isMC ? this.handleQuizMCToggle(index) : this.handleQuizAnswer(index))}
                disabled={quizAnswered}
                type="button"
              >
                <span className={clsx('quiz-mode-option__letter', { 'quiz-mode-option__letter--checkbox': showCheckbox })}>
                  {letterContent}
                </span>
                {isImage ? (
                  <img
                    src={imageSrc}
                    alt={String.fromCharCode(65 + index)}
                    className="quiz-mode-option__image"
                  />
                ) : (
                  <span className="quiz-mode-option__text">{text}</span>
                )}
                {showCheck && (
                  <FontAwesomeIcon
                    icon={['fas', 'check']}
                    className="quiz-mode-option__icon quiz-mode-option__icon--correct"
                  />
                )}
                {showWrong && (
                  <FontAwesomeIcon
                    icon={['fas', 'times']}
                    className="quiz-mode-option__icon quiz-mode-option__icon--wrong"
                  />
                )}
              </button>
            );
          })}
        </div>
        {isMC && !quizAnswered && (
          <button type="button" className="quiz-mode-card__confirm" onClick={this.handleQuizMCConfirm}>
            {i18n.translate('trainingScreens.confirm')}
          </button>
        )}
        {error(false)}
      </div>
    );
  }

  render() {
    const { question, answersCorrect, answer, layout, disableHeader, error, disableToast, correct, completedBefore, quizMode } =
      this.props;

    if (quizMode) {
      return this.renderQuizMode();
    }

    const { answerStyles, activeStyles, toastContent, headerImage } = this.state;

    const activeStylesToUse = completedBefore ? answerStyles : activeStyles;

    return (
      <div
        className="container__question"
        style={{
          pointerEvents: completedBefore ? 'none' : 'auto',
        }}
      >
        {!disableHeader && (
          <div className="container__question--image" style={{ backgroundImage: `url(${headerImage})` }} />
        )}
        <div className="container__question--content">
          <h4 className="container__title">{question}</h4>
          <Inputs
            answer={answer}
            change={(e) => {
              this.changeAnswer(e.target, layout, answersCorrect);
            }}
            changeImage={(e) => {
              this.changeImageAnswer(e, answersCorrect);
            }}
            layout={layout}
            answersCorrect={answersCorrect}
            answerStyles={answerStyles}
            activeStyles={activeStylesToUse}
            completedBefore={completedBefore}
          />
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => {
                this.setState({ toastContent: null });
              }}
              {...toastContent}
            />
          )}
          {layout === 'mMC' && !completedBefore ? (
            <button onClick={(e) => this.checkAnswers(answersCorrect, e.target)}>
              {i18n.translate('trainingScreens.confirm')}
            </button>
          ) : null}
        </div>
        {error(false)}
        {correct(false)}
      </div>
    );
  }
}

const Inputs = (props) => {
  const { answerStyles, activeStyles, answer, change, layout, changeImage, completedBefore, answersCorrect } = props;

  const inputs = [];
  return (
    <div className={`form__answers ${layout === 'mCI' ? 'images' : ''}`}>
      {answer.forEach((answerString, index) => {
        const key = index;
        if (layout === 'mCI') {
          const isTrue = (v) => v === true || (typeof v === 'string' && v.toLowerCase() === 'true');
          inputs.push(
            <ImageAnswer
              change={changeImage}
              key={key}
              id={key}
              text={answerString}
              layout={layout}
              defaultChecked={completedBefore ? isTrue(answersCorrect[index]) : undefined}
            />,
          );
        } else {
          const isTrue = (v) => v === true || (typeof v === 'string' && v.toLowerCase() === 'true');
          inputs.push(
            <Answer
              change={change}
              key={key}
              id={key}
              text={answerString}
              layout={layout}
              answerStyle={answerStyles[index]}
              activeStyle={activeStyles[index]}
              defaultChecked={completedBefore ? isTrue(answersCorrect[index]) : undefined}
            />,
          );
        }
      })}
      {inputs}
    </div>
  );
};

const ImageAnswer = (props) => {
  const { text, change, id, defaultChecked } = props;
  const image = text.replace(' ', '_').toLowerCase();

  return (
    <div
      className={clsx('input__answer', {
        'input__answer--selected': defaultChecked === true,
      })}
    >
      <span
        className="image"
        onClick={(e) => {
          change(e);
        }}
        onKeyPress={(e) => {
          change(e);
        }}
        role="button"
        tabIndex={0}
      >
        <img id={id} src={image} alt="placeholder" />
      </span>
    </div>
  );
};

const Answer = (props) => {
  const { change, id, layout, text, activeStyle } = props;
  const { defaultChecked } = props;
  return (
    <label htmlFor={id} className={activeStyle}>
      <input
        onChange={(e) => change(e)}
        id={id}
        type={`${layout === 'mMC' ? 'checkbox' : 'radio'}`}
        name="answer"
        value={text}
        defaultChecked={defaultChecked}
      />{' '}
      <span
        onClick={(e) => {
          e.target.previousSibling.checked = true;
          change(e);
        }}
        onKeyPress={(e) => {
          e.target.previousSibling.checked = true;
          change(e);
        }}
        role="button"
        tabIndex={0}
      >
        {' '}
        {props.text}
      </span>
    </label>
  );
};

MultipleChoice.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  answersCorrect: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.bool)])
    .isRequired,
  contentComplete: PropTypes.func,
  correct: PropTypes.func,
  correctAnswerText: PropTypes.string,
  disableHeader: PropTypes.bool,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  layout: PropTypes.string,
  question: PropTypes.string,
  disableToast: PropTypes.bool,
  quizMode: PropTypes.bool,
  quizTimerExpired: PropTypes.bool,
};

MultipleChoice.defaultProps = {
  contentComplete: false,
  correctAnswerText: '',
  correct: () => {},
  disableHeader: false,
  error: () => {},
  incorrectAnswerText: '',
  layout: 'mMC',
  question: '',
  disableToast: false,
  quizMode: false,
  quizTimerExpired: false,
};

Inputs.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  change: PropTypes.func,
  changeImage: PropTypes.func,
  answerStyles: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeStyles: PropTypes.arrayOf(PropTypes.string).isRequired,
  layout: PropTypes.string,
};

Inputs.defaultProps = {
  change: () => {},
  changeImage: () => {},
  layout: 'mMC',
};

Answer.propTypes = {
  activeStyle: PropTypes.string.isRequired,
  layout: PropTypes.string,
  text: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  change: PropTypes.func.isRequired,
  defaultChecked: PropTypes.bool,
};

Answer.defaultProps = {
  layout: 'mMC',
  defaultChecked: undefined,
};

ImageAnswer.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  change: PropTypes.func.isRequired,
};
